export default defineNuxtRouteMiddleware(() => {
	const routeUrl = useRouteUrl()
	const companyStore = useCompanyStore()
	if (companyStore.payrollDomainCompany?.id) {
		return navigateTo(routeUrl.CompanyLoginUrl(companyStore.payrollDomainCompany?.id))
	}
})
